import React, { useState, useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Textarea,
    Button,
    Flex,
    Box,
} from '@chakra-ui/react';



const EditAIPromptDialog = ({
    isOpen,
    onClose,
    initialPrompt,
    actualPrompt,
    onPromptSaved,
    handlePromptSave,
}) => {
    const [prompt, setPrompt] = useState(initialPrompt || '');
    const [originalPrompt, setOriginalPrompt] = useState(initialPrompt || '');
    const [isSaving, setIsSaving] = useState(false);


    useEffect(() => {
        setPrompt(actualPrompt || '');
        setOriginalPrompt(initialPrompt || '');
    }, [initialPrompt, isOpen, actualPrompt]);

    const handleSave = async () => {
        setIsSaving(true);
        await handlePromptSave(prompt);
        setIsSaving(false);
        onPromptSaved();
    };

    const handleRevert = async () => {
        const revertPrompt = originalPrompt;
        await handlePromptSave(revertPrompt);
        setIsSaving(false);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Edit AI Prompt</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Textarea
                        value={prompt}
                        onChange={e => setPrompt(e.target.value)}
                        minH="180px"
                        fontSize="sm"
                        placeholder="Enter the core prompt for your AI agent..."
                    />
                </ModalBody>
                <ModalFooter>
                    <Flex w="100%" justify="space-between">
                        <Button variant="ghost" onClick={handleRevert} isDisabled={prompt === originalPrompt}>
                            Revert to Original
                        </Button>
                        <Box>
                            <Button onClick={onClose} mr={3} variant="outline">
                                Cancel
                            </Button>
                            <Button colorScheme="purple" onClick={handleSave} isLoading={isSaving}>
                                Save
                            </Button>
                        </Box>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default EditAIPromptDialog;